import type { HelpFile } from '../../types/help'
import { EnforcementObjectDetailTestIds } from '../../../testids/EnforcementObjectDetailTestIds'

export const enforcementObjectDetailHelp: HelpFile = {
  docPage: '/docs/target-systems/enforcement-objects',
  texts: {
    [EnforcementObjectDetailTestIds.enforcementObjectDetailPage]:
      'Details for an enforcement object — the technical artefact (group, role, ACL entry) that grants access in a target system.',
    [EnforcementObjectDetailTestIds.cardEnforcementObjectDetails]: null,
    [EnforcementObjectDetailTestIds.cardTitleAccessProfiles]:
      'Access profiles that include this enforcement object in their grant set.',
    [EnforcementObjectDetailTestIds.cardTitleRelatedEntities]: null,
    [EnforcementObjectDetailTestIds.colName]: null,
    [EnforcementObjectDetailTestIds.colResource]: null,
    [EnforcementObjectDetailTestIds.colRiskLevel]:
      'Risk classification assigned to this enforcement object.',
    [EnforcementObjectDetailTestIds.colStatus]: null,
    [EnforcementObjectDetailTestIds.linkResourceDetail]: null,
    [EnforcementObjectDetailTestIds.linkSystemDetail]: null,
  },
}
